import React, { FC } from 'react';

import { IFiltersByItem } from '../FilterByItem/filter-by-item.interface';

import { deleteValues, loadState, saveState } from 'utils';
import { ActiveFilters } from 'views/components/ActiveFilters';

interface IFilterManagementProps {
  filterNames: IFiltersByItem[];
  setFilterNames: (filterNames: IFiltersByItem[]) => void;
  keyValue: string;
  onFilterNamesChange?: (filterNames: IFiltersByItem[]) => void;
}

const FILTERS_TO_REMOVE = 1;
const EMPTY_FILTERS_COUNT = 0;

const FilterManagement: FC<IFilterManagementProps> = props => {
  const { filterNames, setFilterNames, keyValue, onFilterNamesChange } = props;

  const onRemoveFilter = (id: number): void => {
    if (onFilterNamesChange) {
      onFilterNamesChange(filterNames.filter((_, index) => index !== id));
      return;
    }

    const storedEntries = loadState<IFiltersByItem[]>(keyValue);
    const existingEntries = Array.isArray(storedEntries)
      ? [...storedEntries]
      : [...filterNames];
    existingEntries.splice(id, FILTERS_TO_REMOVE);
    if (existingEntries.length === EMPTY_FILTERS_COUNT) {
      deleteValues(keyValue);
      setFilterNames([]);
    } else {
      saveState(keyValue, existingEntries);
      setFilterNames(existingEntries);
    }
  };

  const onRemoveAllFilters = (): void => {
    if (onFilterNamesChange) {
      onFilterNamesChange([]);
      return;
    }

    deleteValues(keyValue);
    setFilterNames([]);
  };

  return (
    <ActiveFilters
      filters={filterNames.map((filterName, index) => ({
        id: filterName.id,
        label: filterName.name,
        onRemove: () => onRemoveFilter(index),
      }))}
      onClearAll={onRemoveAllFilters}
    />
  );
};
export { FilterManagement };
